import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedModule } from '@modules';
import { UiNgLetModule } from '@uipath/angular/directives/ui-ng-let';

import { UiBreadCrumbsComponent } from './ui-breadcrumbs.component';

@NgModule({
    imports: [
        CommonModule,
        SharedModule,
        UiNgLetModule,
    ],
    declarations: [
        UiBreadCrumbsComponent,
    ],
    exports: [
        UiBreadCrumbsComponent,
    ],
})
export class UiBreadCrumbsModule { }
